$(function () {
    // Initialize Lenis smooth scroll AFTER ScrollTrigger is set up
  var lenis;
  var lenisTicker;
  function reconnectLenis() {
    // Check if Lenis is available
    if (typeof Lenis === "undefined") {
      console.warn("Lenis library is not loaded");
      return;
    }

    // Destroy existing instance if it exists
    if (lenis) {
      if (lenisTicker) {
        gsap.ticker.remove(lenisTicker);
        lenisTicker = null;
      }
      lenis.destroy();
      lenis = null;
    }

    try {
      lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(1.5, -10 * t)),
        orientation: "vertical",
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 1,
        infinite: false,
      });

      // Connect Lenis scroll to ScrollTrigger
      lenis.on("scroll", ScrollTrigger.update);

      // Use GSAP ticker for Lenis animation loop - store reference
      lenisTicker = function (time) {
        if (lenis) {
          lenis.raf(time * 1000);
        }
      };

      gsap.ticker.add(lenisTicker);
      gsap.ticker.lagSmoothing(0);

      // Initial refresh after Lenis is ready
      setTimeout(function () {
        ScrollTrigger.refresh();
      }, 50);
    } catch (error) {
      console.error("Error initializing Lenis:", error);
    }
  }

  // Initialize Lenis after ScrollTrigger batch is ready
  reconnectLenis();

  // Refresh ScrollTrigger after everything is loaded and Lenis is ready
  // This ensures animations trigger correctly even if elements are initially in view
  setTimeout(function () {
    if (lenis) {
      lenis.resize();
    }
    ScrollTrigger.refresh();
    // Force a scroll update to trigger any elements already in view
    requestAnimationFrame(function () {
      ScrollTrigger.update();
    });
  }, 500);

  // Refresh ScrollTrigger when tabs change
  $(document).on(
    "shown.bs.tab",
    'button[data-bs-toggle="tab"], a[data-bs-toggle="tab"]',
    function () {
      ScrollTrigger.refresh();
      // Refresh Lenis to recalculate dimensions after tab content changes
      if (lenis) {
        setTimeout(function () {
          lenis.resize();
          ScrollTrigger.refresh();
        }, 100);
      }
    }
  );

  // Refresh ScrollTrigger when page becomes visible again (after switching browser tabs)
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) {
      ScrollTrigger.refresh();
      if (lenis) {
        lenis.resize();
        ScrollTrigger.refresh();
      }
    }
  });
});